import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const typographyVariants = cva("", {
  variants: {
    variant: {
      h1: "font-extrabold text-6xl tracking-tight uppercase leading-tight text-center",
      h2: "font-bold text-2xl leading-normal",
      body: "text-base font-medium leading",
    },
  },
})

interface TypographyProps
  extends React.HTMLAttributes<HTMLHeadingElement | HTMLParagraphElement>,
    VariantProps<typeof typographyVariants> {
  as?: React.ElementType
}

const Typography = React.forwardRef<
  HTMLHeadingElement | HTMLParagraphElement,
  TypographyProps
>(({ className, variant, as, ...props }, ref) => {
  const Component =
    as || ((variant?.startsWith("h") ? variant : "p") as React.ElementType)

  return (
    <Component
      ref={ref}
      className={cn(typographyVariants({ variant }), className)}
      {...props}
    />
  )
})
Typography.displayName = "Typography"

export { Typography, typographyVariants }
